import { combineReducers } from 'redux';
import wallet from './wallet';
import auth from './auth';
import Voucher from './Voucher';
export default combineReducers({
  auth,
  wallet,
  value: Voucher,
});
